import { ContentWrapper } from '../..'
import { useTranslationData } from '../../../contexts'
import { getEnvUILangOptions } from '../../../utils'
import { DesktopLanguageSelect } from './desktop'
import { MobileLanguageSelect } from './mobile'

interface TopBarLanguageSelectProps {
  isMobile: boolean
}

export const TopBarLanguageSelect = ({
  isMobile
}: TopBarLanguageSelectProps) => {
  const { UILanguage, selectUILanguage } = useTranslationData()

  const languageOptions = getEnvUILangOptions()

  return (
    <ContentWrapper showContent={languageOptions.length > 1}>
      {isMobile ? (
        <MobileLanguageSelect
          languageOptions={languageOptions}
          selectUILanguage={selectUILanguage}
          UILanguage={UILanguage}
        />
      ) : (
        <DesktopLanguageSelect
          languageOptions={languageOptions}
          selectUILanguage={selectUILanguage}
          UILanguage={UILanguage}
        />
      )}
    </ContentWrapper>
  )
}
